<template>
  <div id="leftnav" v-if="leftdatalist.length>0">
    <el-menu :default-active="activeName"  class="el-menu-vertical-demo">

      <template v-for="(item,index) in leftdatalist">
        <!--两层-->
        <el-submenu :index="item.permissionId" v-if="item.level==2">
          <template slot="title">
            <i class="iconfont" v-html="item.icon" style="margin-right: 5px;"></i>
            <span slot="title" style="font-size: 16px">{{item.name}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item  @click="selectClick(item1)" :index="item1.permissionId" v-for="(item1,index1) in item.menuList" :key="index+'-'+index1">{{item1.name}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!--一层-->
        <el-menu-item :index="item.permissionId" v-if="item.level==1" @click="selectClick(item)">
          <i class="iconfont" v-html="item.icon" style="margin-right: 5px;"></i>
          <span slot="title" style="font-size: 16px">{{item.name}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>


</template>

<script>

  import iconfont from '../../assets/styles/iconfont.css'
  import {getActiveName} from '../../utils/activeName'

    export default {
        name: "leftnav",
        data(){
          return{
            route:this.$route.path,
            leftdatalist:this.$store.state.menuList

          }
        },
      props:{
        // leftdatalist:{
        //   type:Array,
        //   default:[]
        // }
      },
      computed: {
        activeName() {
          // con
          // console.log('this.$route.name',this.$route.name)
          for(var i=0; i<this.leftdatalist.length;i++){
            if(this.leftdatalist[i].level=='2'){
              var item = this.leftdatalist[i].menuList;

              for(var j =0;j<item.length;j++){
                if(this.$route.name==item[j].collection){
                  this.$store.commit('SET_temId', item[j].temId?item[j].temId:'');
                  return item[j].permissionId;
                }
              }
            }else if(this.leftdatalist[i].level=='1'){
              var item = this.leftdatalist[i];

              if(this.$route.name==item.collection) {

                this.$store.commit('SET_temId', item.temId ? item.temId : '');
                return item.permissionId;
              }
            }
          }
        }
        },
        mounted(){
          this.leftdatalist=this.$store.state.menuList
          // console.log('=====',this.leftdatalist)
        },
        methods:{

          selectClick(item1){
            // console.log('=====',item1);
            if(this.$router.history.current.name==item1.collection){
              // console.log('不要重复点击啦！')
              return;
            }
            this.$store.commit('SET_temId', item1.temId)
            var timestamp = Date.now() + Math.floor(Math.random() * 100000);
            this.$router.push({
              name: item1.collection,
              query:{
                timestamp:timestamp
              }
            })
          },
        },

    }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
#leftnav{
  position: fixed;
  left: 0;
  width: 200px;
  background: #fff;
  top: 70px;
  z-index: 999;
  height: calc(100% - 70px);

  /deep/.el-menu-item-group__title{
    padding: 0;
  }
  /*overflow: scroll;*/
  .itemcontent{
    .isselect{
      color: #0a7afc;
    }
    .isnorselect{
      color: #545d6b;
    }
    .itemclassList{
      height: 50px;
      line-height: 50px;
      position: relative;
      cursor: pointer;
      .iconfont{
        margin: 0 16px;
      }
      span{
        font-size: 16px;
      }
      .pick {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        transform-origin: center center;
        transition: transform 0.3s;
      }
    }
    .subclassList{
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      span{
        font-size: 16px;
        margin-left: 53px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/LeftNav/index.vue